<template>
  <div
    class="rank_picker"
    :class="[
      currentGameSlug,
      isSelected && 'selected',
      isDisabled && 'disabled',
    ]"
    @click="() => selectRank(rank)"
  >
    <img
      class="picker_rank_image"
      :alt="rankTitle + ' Game rank image'"
      :src="rankImage"
      :id="rankTitle"
      height="30"
      width="30"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    rankImage: {
      type: String,
      default: "",
    },
    rankTitle: {
      type: String,
      default: "",
    },
    rank: {
      default: null,
    },
    selectRank: {
      default: () => {},
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { currentGameSlug } = useGameComposable();
    return {
      currentGameSlug,
    };
  },
};
</script>
